type I18nInstance = {
  addResourceBundle: (
    language: string,
    namespace: string,
    resources: object,
    deep?: boolean,
    overwrite?: boolean,
  ) => void;
  languages: readonly string[];
};

type LocaleResources = Record<string, Record<string, unknown>>;

export function transformPlaceholders(obj: unknown): unknown {
  if (typeof obj === 'string') return obj.replace(/\{(\w+)\}/g, '{{$1}}');
  if (typeof obj === 'object' && obj !== null) {
    return Object.fromEntries(
      Object.entries(obj as Record<string, unknown>).map(([k, v]) => [k, transformPlaceholders(v)]),
    );
  }
  return obj;
}

export function registerWithI18next(i18n: I18nInstance, namespace: string, resources: LocaleResources): void {
  for (const [locale, dict] of Object.entries(resources)) {
    i18n.addResourceBundle(locale, namespace, transformPlaceholders(dict) as object, true, true);
  }
}
